import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const PageSkeletonReferrals = () => {
  return (
    <Box sx={{ width: '100%', marginTop: '20px' }}>
      <Box sx={{ 
        display: 'flex',
        flexDirection: {xs: 'column', md: 'row'},
        border: '1px solid #E4EBF6',
        borderRadius: '12px',
        bgcolor: 'white',
        gap: '32px',
        overflow: 'hidden',
        maxHeight: {xs: 'none', md: '450px'},
        alignItems: 'center'
      }}>
        <Box sx={{
          width: {xs: '100%', md: '50%'},
          padding: {xs: '20px', md: '24px'},
          boxSizing: 'border-box'
        }}>
          <Skeleton variant="text" width="120px" height={24} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="90%" height={32} sx={{ my: 2, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="100%" height={20} sx={{ mb: 4, bgcolor: '#E6EDF9' }} />
          
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)'},
            gap: 2
          }}>
            {[1,2,3,4].map((item) => (
              <Box key={item} sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                borderLeft: '2px solid #CED4FC',
                pl: 1.5
              }}>
                <Skeleton variant="text" width="60px" height={32} sx={{ bgcolor: '#E6EDF9' }} />
                <Skeleton variant="text" width="100%" height={20} sx={{ bgcolor: '#E6EDF9' }} />
              </Box>
            ))}
          </Box>
        </Box>

        <Box sx={{
          width: {xs: '100%', md: '50%'},
          height: {xs: '200px', md: '450px'},
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Skeleton variant="rectangular" width="100%" height="100%" sx={{ bgcolor: '#E6EDF9' }} />
        </Box>
      </Box>
    </Box>
  );
};

export default PageSkeletonReferrals;
